export default {
  eyebrow: 'Portail partenaire',
  title: 'Taxe et devise',
  description:
    "Catégories de taxes par défaut héritées par vos restaurants, sauf s'ils les remplacent individuellement.",
};
